var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHorizontalBarChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66797 1C6.22025 1 6.66797 1.44772 6.66797 2V4C6.66797 4.55228 6.22025 5 5.66797 5H2.66797C2.11568 5 1.66797 4.55228 1.66797 4V2C1.66797 1.44772 2.11568 1 2.66797 1H5.66797Z",
    fill: "#4559A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66797 6C10.2203 6 10.668 6.44772 10.668 7V9C10.668 9.55228 10.2203 10 9.66797 10H2.66797C2.11568 10 1.66797 9.55228 1.66797 9V7C1.66797 6.44772 2.11568 6 2.66797 6H9.66797Z",
    fill: "#4559A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.668 11C15.2203 11 15.668 11.4477 15.668 12V14C15.668 14.5523 15.2203 15 14.668 15H2.66797C2.11568 15 1.66797 14.5523 1.66797 14V12C1.66797 11.4477 2.11568 11 2.66797 11H14.668Z",
    fill: "#4559A7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalBarChart);
export default __webpack_public_path__ + "static/media/horizontal-bar-chart.2b062eaa3638e22d707d201372a95038.svg";
export { ForwardRef as ReactComponent };